import React from "react"
import {Box, CircularProgress, Container, Grid, Typography} from "@mui/material";

export default function Loading() {
    return (
        <Container maxWidth={"md"} sx={{textAlign: "center", minHeight: "100vh"}}>
            <Box sx={{
                mt: 15,
                mb: 8,
            }}>
                <CircularProgress/>
            </Box>
            <Typography align={"center"}>
                Chargement...
            </Typography>
        </Container>
    )
}